<template>
    <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
        <div class="kgr-grid__cell">
            <kgr-profile-part :heading="dog.name">
                <template #content>
                    <div class="kgr-postfix kgr-postfix--bigGutters">
                        <div class="kgr-postfix__fixed">
                            <kgr-profile-image
                                :src="dogAvatarUrl(dog)"
                                :alt="dog.name"
                                size="M"
                            />
                        </div>
                        <div class="kgr-postfix__fluid">
                            <table class="kgr-table">
                                <tbody>
                                    <tr class="kgr-table__row kgr-table__row--top">
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Geschlecht') }}
                                        </td>
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ dog.gender !== null ? $t(dog.gender) : $t('gender.u') }}
                                        </td>
                                    </tr>
                                    <tr class="kgr-table__row kgr-table__row--top">
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Rasse') }}
                                        </td>
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ dogBreed }}
                                        </td>
                                    </tr>
                                    <tr class="kgr-table__row kgr-table__row--top">
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Rasse Spezialisierung') }}
                                        </td>
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ dogBreedSpecialization }}
                                        </td>
                                    </tr>
                                    <tr
                                        class="kgr-table__row kgr-table__row--top"
                                    >
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Wurfdatum') }}
                                        </td>
                                        <td class="kgr-table__cell">
                                            <div>
                                                {{ dog.dateOfBirth || '-' }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        class="kgr-table__row kgr-table__row--top"
                                    >
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Todesdatum') }}
                                        </td>
                                        <td class="kgr-table__cell">
                                            <div>
                                                {{ dog.dateOfDeath || '-' }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        class="kgr-table__row kgr-table__row--top"
                                    >
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Chipnummer') }}
                                        </td>
                                        <td class="kgr-table__cell">
                                            <div>
                                                {{ dog.chipNumber || '-' }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        class="kgr-table__row kgr-table__row--top"
                                    >
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Zuchtbuchnummer') }}
                                        </td>
                                        <td class="kgr-table__cell">
                                            <div>
                                                {{ dog.breedingBookNumber || '-' }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="ownerRelations.length > 0"
                                        class="kgr-table__row kgr-table__row--top"
                                    >
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('club.dog.memberRelation.association.owner') }}
                                        </td>
                                        <td class="kgr-table__cell">
                                            <div
                                                v-for="relation in ownerRelations"
                                                :key="relation.id"
                                            >
                                                <a :href="memberUrl(relation.member)">
                                                    ⸰ {{ relation.member.fullName() }}
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="handlerRelations.length > 0"
                                        class="kgr-table__row kgr-table__row--top"
                                    >
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('club.dog.memberRelation.association.handler') }}
                                        </td>
                                        <td class="kgr-table__cell">
                                            <div
                                                v-for="relation in handlerRelations"
                                                :key="relation.id"
                                            >
                                                <a :href="memberUrl(relation.member)">
                                                    ⸰ {{ relation.member.fullName() }}
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="dog.memberClubFees.length > 0"
                                        class="kgr-table__row kgr-table__row--top"
                                    >
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Verknüpfte Beiträge') }}
                                        </td>
                                        <td class="kgr-table__cell">
                                            <div
                                                v-for="fee in dog.memberClubFees"
                                                :key="fee.id"
                                            >
                                                ⸰ {{ fee.name }}
                                                (
                                                <a :href="memberUrl(fee.member)">
                                                    {{ fee.member.firstName }} {{ fee.member.lastName }}
                                                </a>
                                                )
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="dog.passedExams.length > 0"
                                        class="kgr-table__row kgr-table__row--top"
                                    >
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Zuletzt bestandene Prüfung') }}
                                        </td>
                                        <td class="kgr-table__cell">
                                            <div
                                                v-for="passedExam in dog.passedExams"
                                                :key="passedExam.id"
                                            >
                                                ⸰ {{ passedExam.title }} - {{ passedExam.examDate }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="dog.usabilityPass !== undefined"
                                        class="kgr-table__row kgr-table__row--top"
                                    >
                                        <td
                                            class="kgr-table__cell"
                                        >
                                            {{ $t('Brauchbarkeitspass') }}
                                        </td>
                                        <td class="kgr-table__cell">
                                            <a
                                                v-if="dog.usabilityPass.exhibited"
                                                :href="dog.usabilityPass.url"
                                            >
                                                ⸰ {{ $t('erstellt am {date}', {date: dog.usabilityPass.exhibitionDate}) }}
                                            </a>
                                            <span
                                                v-else
                                                :title="tNoUsabilityPassTitle"
                                            >
                                                -
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>
            </kgr-profile-part>
        </div>
    </div>
</template>

<script>
import Dog from '../../js/dto/Dog.js';
import DogRepository from '../../js/repository/DogRepository.js';
import ProfileImage from '../../components/common/ProfileImage.vue';
import ProfilePart from '../../components/short-profile/ProfilePart.vue';
import UrlMixin from '../members/UrlMixin.vue';

export default {
    components: {
        'kgr-profile-part': ProfilePart,
        'kgr-profile-image': ProfileImage,
    },
    mixins: [UrlMixin],
    props: {
        dog: {
            type: Dog,
            required: true,
        },
    },
    computed: {
        ownerRelations() {
            return this.dog.relations.filter(r => r.association === 'owner');
        },
        handlerRelations() {
            return this.dog.relations.filter(r => r.association === 'handler');
        },
        dogBreed() {
            return this.dog.breed?.label ?? '-' ;
        },
        dogBreedSpecialization() {
            return this.dog.breedSpecialization?.label ?? '-' ;
        },
        tNoUsabilityPassTitle() {
            return this.$t('Ein Brauchbarkeitspass wurde noch nicht erstellt');
        },
    },
    methods: {
        dogAvatarUrl(dog) {
            return dog.hasAvatar ? DogRepository.avatarUrl(dog.id, dog.avatarFileName) : kgr.assetsUrls['clubityAvatarDogUnknown'];
        },
        memberUrl(member) {
            return this.urlForMember(member.id);
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
